import Form from '../../components/form/form'
import '../../sass/containers/_contact.scss'

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <h2 className="contact__title">Contact</h2>
      <Form />
    </section>
  )
}

export default Contact
